import React, {Component} from "react";

import logoWb from "../assets/images/logo_v2.png";
import {Link} from "react-router-dom";

class Footer extends Component {
	render() {
		return (
			<div className="footer">
				<div className="footer__data">
					<div className="footer__data-logo logo">
						<Link to={''}>
							<img src={logoWb}/>
						</Link>
					</div>
				</div>
			</div>
		);
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/app/Footer.js